import gdriveIcon from 'assets/images/gdrive.svg';
import onedriveIcon from 'assets/images/onedrive.svg';
import sharepointIcon from 'assets/images/sharepoint.svg';
import githubIcon from 'assets/images/social_media_github.svg';
import googleIcon from 'assets/images/social_media_google.svg';
import type { AgentAttachedTool } from 'features/chat/agent-chat-module/types/agent.service.type';
import { resolveComposioToolLogo } from 'pages/tools/components/composio-logos';

export const AGENT_CARD_MAX_PROVIDER_ICONS = 3;

const PUBLIC_PROVIDER_ICONS: Record<string, string> = {
  DISCORD: '/assets/images/agents/discord.png',
  SLACK: '/assets/images/agents/slack.png',
  TEAMS: '/assets/images/agents/teams.png',
  MICROSOFT_TEAMS: '/assets/images/agents/teams.png',
  MICROSOFTTEAMS: '/assets/images/agents/teams.png',
  TELEGRAM: '/assets/images/agents/telegram.png',
  WHATSAPP: '/assets/images/agents/whatsapp.png',
};

const LOCAL_PROVIDER_ICONS: Record<string, string> = {
  GDRIVE: gdriveIcon,
  GOOGLEDRIVE: gdriveIcon,
  GOOGLE_DRIVE: gdriveIcon,
  GOOGLE: googleIcon,
  GMAIL: googleIcon,
  GOOGLECALENDAR: googleIcon,
  GOOGLE_CALENDAR: googleIcon,
  GITHUB: githubIcon,
  ONEDRIVE: onedriveIcon,
  ONE_DRIVE: onedriveIcon,
  SHAREPOINT: sharepointIcon,
};

const SIMPLE_ICONS_CDN: Record<string, string> = {
  NOTION: 'https://cdn.simpleicons.org/notion',
  GOOGLECALENDAR: 'https://cdn.simpleicons.org/googlecalendar',
  GOOGLE_CALENDAR: 'https://cdn.simpleicons.org/googlecalendar',
  GMAIL: 'https://cdn.simpleicons.org/gmail',
};

export function normalizeProviderSlug(value: string): string {
  return value.trim().toUpperCase().replace(/[\s-]+/g, '_');
}

export function resolveToolProviderIcon(
  provider: string,
  catalogLogos?: Map<string, string>
): string | null {
  const fromComposio = resolveComposioToolLogo(provider);
  if (fromComposio) return fromComposio;

  const slug = normalizeProviderSlug(provider);
  if (!slug) return null;

  const fromCatalog = catalogLogos?.get(slug) ?? catalogLogos?.get(slug.replace(/_/g, ''));
  if (fromCatalog) return fromCatalog;

  return (
    LOCAL_PROVIDER_ICONS[slug] ??
    PUBLIC_PROVIDER_ICONS[slug] ??
    LOCAL_PROVIDER_ICONS[slug.replace(/_/g, '')] ??
    PUBLIC_PROVIDER_ICONS[slug.replace(/_/g, '')] ??
    SIMPLE_ICONS_CDN[slug] ??
    SIMPLE_ICONS_CDN[slug.replace(/_/g, '')] ??
    null
  );
}

export type AgentCardProviderIcon = {
  slug: string;
  label: string;
  src: string | null;
};

export function getAgentCardProviderIcons(
  tools?: AgentAttachedTool[] | null,
  catalogLogos?: Map<string, string>
): AgentCardProviderIcon[] {
  const seen = new Set<string>();
  const icons: AgentCardProviderIcon[] = [];

  for (const tool of tools ?? []) {
    const sources = (tool.providers ?? []).filter((provider) => provider.trim());
    if (sources.length === 0 && tool.name.trim()) {
      sources.push(tool.name);
    }

    for (const provider of sources) {
      const slug = normalizeProviderSlug(provider);
      if (!slug || seen.has(slug)) continue;
      seen.add(slug);
      icons.push({
        slug,
        label: tool.name || provider.trim(),
        src:
          resolveToolProviderIcon(provider, catalogLogos) ??
          resolveToolProviderIcon(tool.name, catalogLogos),
      });
    }
  }

  return icons;
}
